import { useEffect, useState, useRef } from 'react'
import TextBoxControl from '../../Controls/TextBoxControl';
import ButtonControl from "../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../assets/css/Login.css"
import {
    SetLocal,
    ClearLocal,
    FetchService,
    IsValidNationalCode,
    IsEmptyString,
    IsEmptyInput,
    Base64Type,
    GetParamsUrl
} from "../../Base/BaseControl";
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';


let FileExt = '';
export default function Index({ }) {


    const [getServiceResult, setServiceResult] = useState(null);
    const [getUrbanName, setUrbanName] = useState('');
    const [getFileLogo, setFileLogo] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [getPdf, setPdf] = useState('');

    const navigate = useNavigate();


    useEffect(() => {
        if (GetParamsUrl("sys") && GetParamsUrl("key")) {
            fechQuickPaymentInfo()
            GetLogo();
            GetUrbanName();
        }

    }, []);

    const fechQuickPaymentInfo = () => {

        let inputValue = {
            sys: GetParamsUrl("sys"),
            key: GetParamsUrl('key'),
        };
        FetchService("Owner/Financial/Factor/QuickPaymentInfo", inputValue, fechQuickPaymentInfoSuccess);
    }



    const fechQuickPaymentInfoSuccess = (ServiceResult) => {
        const quickPaymentData = {
            Amount: ServiceResult.Amount,
            Status: ServiceResult.Status,
            IsDisplayable: ServiceResult.IsDisplayable,
            IsPayable: ServiceResult.IsPayable,
            SerialNumber: ServiceResult.SerialNumber,
            PaymentRequstType: ServiceResult.PaymentRequstType, // 1 , 0
        }
        setServiceResult(quickPaymentData)
        SetLocal("IPGType", quickPaymentData?.PaymentRequstType)


    }

    const GetLogo = () => {
        var inputValue = {};
        FetchService("General/GetLogo", inputValue, GetLogoSuccess);
    }

    const GetLogoSuccess = (serviceResult) => {
        setFileLogo(serviceResult.entity);
    }

    const GetUrbanName = () => {
        var inputValue = {};
        FetchService("General/GetUrbanName", inputValue, GetUrbanNameSuccess);
    }

    const GetUrbanNameSuccess = (serviceResult) => {
        setUrbanName(serviceResult.entity);
    }

    const viewReceipt = () => {
        let inputValue = {
            systemNumber: GetParamsUrl("sys"),
            serialNumber: GetParamsUrl('key'),
        };
        FetchService("Owner/Financial/Report/QuickPaymentReport", inputValue, viewReceiptSuccess)

    }
    const viewReceiptSuccess = (ServiceResult) => {
        setPdf("data:application/pdf;base64," + ServiceResult);
        setShowModal(true)
    }

    const makeIPGPayment = () => {
        let inputValue = {
            systemNumber: GetParamsUrl("sys"),
            serialNumber: GetParamsUrl('key'),
        };
        let IPGType = getServiceResult?.PaymentRequstType
        if (IPGType === 1) {
            FetchService("Owner/Financial/Request/IPGPaymentRequestByNovin", inputValue, makeIPGPaymentSuccess);
        } else if (IPGType === 0 || IPGType === 99) {
            FetchService("Owner/Financial/Request/IPGPaymentRequestByIdentifier", inputValue, makeIPGPaymentSuccess);
        }
    }

    const makeIPGPaymentSuccess = (ServiceResult) => {
        window.location = ServiceResult.RedirectURL + '&returnURL=' + window.location.protocol + '//' + window.location.host + '/QuickPayment/ReturnFromIPG/' + "?sys=" + GetParamsUrl("sys")
    }



    return (
        <div id="bglogin">
            <div className="main">
                <div className="col-12 col-md-4">
                    {(GetParamsUrl("sys") && GetParamsUrl("key")) &&
                        <div className='d-flex flex-column gap-3 justify-content-center align-items-center '>
                            <img src={"data:image/png;base64," + getFileLogo} style={{ width: "120px", margin: "10px auto", cursor: "none" }} />
                            <a
                                href="#"
                                style={{ cursor: "none" }}
                                class="navbar-brand text-center text-sm">
                                {getUrbanName}
                            </a>
                            <ButtonControl
                                onClick={viewReceipt}
                                variant="success col-12"
                                title="نمایش فیش"
                                icon="fa fa-file"
                                disabled={!getServiceResult?.IsDisplayable}
                            />
                            <ButtonControl
                                onClick={makeIPGPayment}
                                variant="primary col-12"
                                title="پرداخت قبض"
                                icon="fa fa-dollar"
                                disabled={!getServiceResult?.IsPayable}
                            />
                            <div className='col-12 ps-2'>
                                <div className=''>
                                    {getServiceResult?.Status}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowModal(false)}>
                        بستن
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}